goog.provide('el8.appchart.dialog.addDiscreteLabValues');

goog.require('el8.app.pageLayout');
goog.require('el8.appchart.dialog.createLabResultTest');
goog.require('el8.appchart.showItemDetail');
goog.require('el8.appservice.notifier');
goog.require('el8.appshared.dialog.discreteLabFields');
goog.require('el8.data.labTestVendors');
goog.require('el8.service.urls');
goog.require('el8.template.appshared.dialog.addDiscreteLabValues');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.consts');
goog.require('el8.app.shared.documentImageRenderer');


el8.appchart.dialog.addDiscreteLabValues = (function() {

    var associatedLabId = null;
    var existingGridId = null;
    var imageFeed = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Document Lab Results',
        modal: false,
        height: function() {
            return el8.app.pageLayout.getAppInnerHeight();
        },
        position: 'center',
        width: function() {
            return Math.min(el8.app.pageLayout.getAppWidth(), 1250);
        },
        contentFn: function() {
            return el8.template.appshared.dialog.addDiscreteLabValues.chartDialog({
                vendorChoices: el8.data.labTestVendors.allAsSoyMaps()
            });
        }
    });

    var form = new el8.uiwidget.Form({
          //functions inside the discrete lab fields need access to the form object
        fields: el8.appshared.dialog.discreteLabFields.getFields()
    });
    form.addSaveButton(function(_form) {
        doSave(_form);
    }, true);
    form.addDiscardChangesButton(function(_form) {
        that.hide();
    });
    that.setForm(form);

    function validate(_form) {
        // if we do have quick add lab values, then we don't need to check we have vendorId or
        // old way manual lab value entry
        var quickAddLabValues = el8.appshared.dialog.discreteLabFields.getQuickAddLabValues();
        if (!quickAddLabValues) {
            if (!_form.getVal('vendorId') || _form.getVal('vendorId') <= 0) {
                el8.uiwidget.alert('Please select a vendor before saving.');
                return false;
            }
              //if there is an un-added lab, try to add; if we fail, don't save.
              //processTestForm displays its own alert dialogs
            if (el8.appshared.dialog.discreteLabFields.processTestForm() === false) { return false; }
              //then after adding, check if there are labValues
            if (!el8.appshared.dialog.discreteLabFields.hasLabValues()) {
                el8.uiwidget.alert('Please add lab results before saving.');
                return false;
            }
        }
        return true;
    }

    function doSave(_form) {
        if (!validate(_form)) { return; }
        var serverDict = el8.appshared.dialog.discreteLabFields.labValuesForServer();
        if (!serverDict.labValues.length && !serverDict.deletedLabResults.length) { //no modified/deleted/new results
            that.hide();
            return;
        }

        var urlName = existingGridId ? 'updateDiscreteLabs' : 'newDiscreteLabs';
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get(urlName, [associatedLabId, existingGridId]),
            data: {'data': JSON.stringify(serverDict)},
            success: function(data) {
                /* We want to update affected 'previous 3 lab values' and our new report itself. Until we re-work
                 * previous labs, we are just going to re-fetch everything newer than this object */
                el8.appservice.notifier.notify('Updating lab results...');

                var updatedLab = el8.ptdata.getEntitySet('Report').create(data);
                var potentiallyAffectedReports = [];
                el8.ptdata.reports.allByType('lab').map(function(r) {
                    if (r.getDocumentDate() >= updatedLab.getDocumentDate()) {
                        potentiallyAffectedReports.push(r.getId());
                    }
                });

                el8.ptdata.fetch({
                    fetchIds: potentiallyAffectedReports,
                    force: true,
                    async: true,
                    callbackFn: function() {
                        el8.appchart.dialog.reports.refresh('lab', false, false); //synchronous feed.update()
                        el8.appchart.showItemDetail(updatedLab); //and reopen the updated lab
                    }
                });
                that.hide();
            }
        });
    }

    var super_init = that._init;
    that._init = function() {
        el8.data.labTestVendors.softLoad();
        super_init.call(that);
        el8.appshared.dialog.discreteLabFields.init({
            container: that.getContentElt(),
            form: form,
            adjustHeightFn: function() { that.adjustPosition(); }
        });
    };

    // Set sliding pane heights so we have two inner scrollbars instead of one outer scrollbar
    var super_adjustPosition = that.adjustPosition;
    that.adjustPosition = function() {
        super_adjustPosition.call(that);
         //make vertical scroll of the inner panes work
        var dialogHeight = that.getContentElt().height();
        $('.el8SlidingPaneItem', that.getContentElt()).height(dialogHeight);
         //make horizontal scroll of the right pane work
        var rightPaneWidth = that.getContentElt().innerWidth() -
            $('#add-lab-values-chartdialog', that.getContentElt()).parent().outerWidth();
         //the '- 15' is probably an accomodation for scrollbars... either way it makes things work
        $('.chart-dialog-feed-container', that.getContentElt()).outerWidth(rightPaneWidth - 15);
    };

    var super_show = that.show;
    that.show = function(labId) {
        if (!labId) { return; } //need an associated report to add values to
        associatedLabId = labId;
        var labReport = el8.ptdata.reports.getById(associatedLabId);
        super_show.call(that);

        if (labReport.hasGrids()) {
            existingGridId = labReport.getResultGrids()[0].getId(); //there should only be one grid in a manual report
            el8.appshared.dialog.discreteLabFields.populateGrids(labReport.getVendorId(), labReport.getResultGrids());
            el8.appshared.dialog.discreteLabFields.initSectionsWithExistingLabValues(labReport.getVendorId());
            el8.appshared.dialog.discreteLabFields.populatePanelForPatient();
        }
        else {
            el8.appshared.dialog.discreteLabFields.initSectionsWithNoExistingLabValues();
            el8.appshared.dialog.discreteLabFields.populatePanelForPatient();
        }

        var imageSpec = {
            imageWidth: 825,
            imageHeight: 1068,
            imageClass: 'filer'
        };
        imageFeed = el8.app.shared.documentImageRenderer(labReport, imageSpec, $('.chart-dialog-images'));
        imageFeed.display();

        that.adjustPosition();
        form.initFocus();
    };

    var super_hide = that.hide;
    that.hide = function() {

        associatedLabId = null;
        existingGridId = null;
        imageFeed.destroy();
        $('.chart-dialog-feed-container', that.getContentElt()).append(
            el8.template.appshared.dialog.addDiscreteLabValues.reportFeed()
        );
        imageFeed = null;
        el8.appshared.dialog.discreteLabFields.clearDialog();
        super_hide.call(that);
    };

    return that;

})();


